var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contType.includes('detail'))?_c('van-icon',{staticClass:"closeIcon",attrs:{"name":"cross","size":"18"},on:{"click":_vm.exit}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }